/**
 * @generated SignedSource<<172ac337a36da2c43744db7fcf8db848>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactInlineFragment$data = {
  readonly id: string;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly source: string;
  readonly email: string;
  readonly accountId: string;
  readonly createdAt: any | null;
  readonly createdBy: string | null;
  readonly salutation: string | null;
  readonly dob: any | null;
  readonly preferredName: string | null;
  readonly gender: string | null;
  readonly photoUrls: any | null;
  readonly countryId: string | null;
  readonly mobilePhone: string | null;
  readonly workPhone: string | null;
  readonly homePhone: string | null;
  readonly addressLineOne: string | null;
  readonly addressLineTwo: string | null;
  readonly city: string | null;
  readonly state: string | null;
  readonly businessName: string | null;
  readonly occupation: string | null;
  readonly contactActivityHistories: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"contactActivityHistoryInlineFragment">;
  }>;
  readonly contactTeamMembers: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"contactTeamMemberInlineFragment">;
  }>;
  readonly salesOrders: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"salesOrderInlineFragment">;
  }>;
  readonly " $fragmentType": "contactInlineFragment";
};
export type contactInlineFragment$key = {
  readonly " $data"?: contactInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contactInlineFragment"
};

(node as any).hash = "93a80ed32d9b4ebc59d3d57793bfdee2";

export default node;
